/************************************
MODULE:         Dropdown/accordion module
WHAT IT DOES:   finds all types of accordions/drodpowns on page, send them to initialization & adds any additional functionality to them if needed
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else { root.returnExports = factory(root.jQuery); }
}(this, function ($) {

    function init() {
        initTouchDropdowns();
        initFindAStoreDropdown();
        initAccordions();
        initFeefoDropdown();
        initForgottenPasswordDropdown();
        initResumeQuoteDropdown();
        initFindAStoreBoxDropdown();
        initReviewsDropdown();
        initFindAStorePopupDropdown();
        initEnquiryFormDropdowns();
    }

    /*****/
    //usual dropdowns
    function initTouchDropdowns() {
        var dropdowns = $(".js-dropdown").not('.js-inited');
        if (!dropdowns.length)
            return;

        var genericdropdown = require('generic.dropdown');
        dropdowns.addClass('js-inited');

        for (var i = 0, l = dropdowns.length; i < l; i++) {
            dropdowns.eq(i)[0].instance = new genericdropdown(dropdowns.eq(i));
        }
    }
    /*****/

    /*****/
    //My Account sign-in form
    function initForgottenPasswordDropdown() {
        var forgottenPasswordDropdown = $('.js-forgottenpassword-dropdown'),
            link = forgottenPasswordDropdown.find('.js-dropdown-link'),
            content = forgottenPasswordDropdown.find('.js-dropdown-content');
        var genericdropdown = require('generic.dropdown');
        new genericdropdown(forgottenPasswordDropdown, {
            link: link,
            content: content,
            time: 0.5,
            clickCallback: onForgottenPasswordClick
        });
    }

    function onForgottenPasswordClick() {
        var forgottenPasswordDropdown = $('.js-forgottenpassword-dropdown'),
            link = forgottenPasswordDropdown.find('.js-dropdown-link'),
            txtEmailAddress = forgottenPasswordDropdown.find("[id$='txtEmailAddress']"),
            isOpen = forgottenPasswordDropdown.hasClass('opened'),
            signInForm = $('.js-signin-form');

        if (txtEmailAddress.length) {
            if (isOpen) {
                link.hide();
                signInForm.hide();
                $('.js-form-header').text("Please enter your email address");
                txtEmailAddress.removeAttr('disabled');
                txtEmailAddress.focus();
            }
        }
    }
    /*****/

    /*****/
    //Find a store box dropdown
    function initFindAStoreBoxDropdown() {
        var findAStoreDropdown = $('.js-fas-dropdown'),
            link = findAStoreDropdown.find('.js-dropdown-link'),
            content = findAStoreDropdown.find('.js-dropdown-content');
        var genericdropdown = require('generic.dropdown');
        new genericdropdown(findAStoreDropdown, {
            link: link,
            content: content,
            time: 0.5,
            animationCallback: focusInput.bind(findAStoreDropdown)
        });

        $(document).on('click', closeFindAStoreDropdown.bind(findAStoreDropdown));

    }

    function focusInput() {
        if (this.hasClass('opened')) {
            var input = this.find('.js-search-store-input');
            input.focus();
        }
    }
    function closeFindAStoreDropdown(e) {
        if ($(e.target).closest(this).length) return;
        this.trigger('dropdown:close');
        e.stopPropagation();

    }

    function initFindAStorePopupDropdown(){

        var searchStoreInput = $('.js-offer-popup-inner .js-search-store-input');
        if(!searchStoreInput) return;

        $(window).on('resize:finished', popupStickToTop);

        searchStoreInput.focus(function(){
            popupStickToTop();
        });

        searchStoreInput.blur(function(){
            popupStickToTop();
        });

        // move popup upper when focus search field to leave enough space for dropdown
        function popupStickToTop(){
            var searchStoreInput = $('.js-offer-popup-inner .js-search-store-input');

            if(!window.App.globals.isTabletSmall){
                searchStoreInput.parents('.js-offer-popup-inner').css('transform','none');
                return;
            }

            if(searchStoreInput.is(":focus")){
                setTimeout(function(){
                    var inputTopOffset = searchStoreInput[0].getBoundingClientRect().top;
                    var popupMove = -(inputTopOffset) + 15;
                    var popupElement = searchStoreInput.parents('.js-offer-popup-inner');
                    popupElement.css('transform', 'translateY(' + popupMove + 'px)');
                }, 200);
            }else{
                searchStoreInput.parents('.js-offer-popup-inner').css('transform','none');
            }
        }
    }

    /*****/

    /*****/
    //feed dropdowns with additional scrolling functionality
    function initFeefoDropdown() {
        var feefo = $('.js-feefo'),
            feefoContent = $('.js-feefo-content'),
            triggerFeefo = $('.js-show-feefo');

        if (!triggerFeefo.length || !feefo.length || !feefoContent.length)
            return;

        var genericdropdown = require('generic.dropdown');
        new genericdropdown(feefo, {
            link: triggerFeefo,
            content: feefoContent,
            time: 0.5,
            clickCallback: feefoScrollTop.bind(feefo)
        });


    }

    function feefoScrollTop(feefo) {
        var feefo = $('.js-feefo'),
            target = $('#feefo-rating'),
            top = target.offset().top;

        var tweenmax = require('tweenmax');
        var scrolltoplugin = require('scrolltoplugin');

        var tween = new TimelineMax();

        if (!feefo.hasClass('opened')) {
            tween.to(window, 0.5, {scrollTo:{y:top}, ease:Power2.easeOut});
            tween.play();

        } else {
            return;
        }

    }
    /*****/

    /*****/
    //google reviews dropdown
    function initReviewsDropdown() {
        var container = $('.js-reviews'),
            content = $('.js-reviews-content'),
            link = $('.js-reviews-more');

        if (!container.length || !content.length || !link.length)
            return;

        var genericdropdown = require('generic.dropdown');
        new genericdropdown(container, {
            link: link,
            content: content,
            time: 0.5

        });


    }


    /*****/

    /*****/
    //find a store dropdown which can have more then one opening link
    function initFindAStoreDropdown() {
        var findstore = $('.js-find-a-store-bottom-header'),
            triggerFindStore = $('.js-show-findstore');

        if (!triggerFindStore.length || !findstore.length)
            return;

        var genericdropdown = require('generic.dropdown');
        var tweenmax = require('tweenmax');
        var scrolltoplugin = require('scrolltoplugin');

        new genericdropdown(findstore, {
            link: triggerFindStore,
            content: findstore,
            time: 0.3,
            animationCallback: focusFindAtore.bind(findstore)
        });
    }

    function focusFindAtore() {
        if (this.hasClass('opened')) {

            var top = window.App.globals.getTop(),
                offsetTop = this.offset().top + (window.App.globals.isCustomScroll ? top : 0),
                input = this.find('.js-search-store-input');

            for (var i = 0; i < input.length; i++) {
                if (input.eq(i).parents('.find-item').length == 0) {
                    if (top > offsetTop) {
                        TweenMax.to(window, 0.5, { scrollTo: { y: offsetTop }, ease: Power2.easeOut, onComplete: function () { input.eq(i).focus() } });
                    } else {
                        input.eq(i).focus();
                    }
                }
            }

        }
    }
    /*****/

    /*****/
    //Resume quote dropdown
    function initResumeQuoteDropdown() {
        var resumeQuoteDropdown = $('.js-resumequote-dropdown'),
            link = resumeQuoteDropdown.find('.js-dropdown-link'),
            content = resumeQuoteDropdown.find('.js-dropdown-content');
        var genericdropdown = require('generic.dropdown');
        new genericdropdown(resumeQuoteDropdown, {
            link: link,
            content: content,
            time: 0.5,
            clickCallback: setCookie.bind(resumeQuoteDropdown)
        });

        $(window).on('resumedropdown:show', showResumeDropdown);
        $(window).on('resumedropdown:delayShow', showResumeDropdownDelay);
        $(window).on('resumedropdown:hide', hideResumeDropdown);
    }

    function setCookie() {
        var value = (this.hasClass('opened')) ? 'false' : 'true';
        document.cookie = 'IncompletedQuoteBarClosed' + '=' + value +  '; path=/';
    }

    function showResumeDropdown() {
        $('body').addClass('rq-bar-is-shown');
    }

    function showResumeDropdownDelay() {
        var resumeDropdown = $('.js-resumequote-dropdown');
        resumeDropdown.trigger('dropdown:close');
        $('body').addClass('rq-bar-is-shown');

        setTimeout(function(){
            resumeDropdown.trigger('dropdown:open');
        }, 2000);
    }

    function hideResumeDropdown() {
        $('body').removeClass('rq-bar-is-shown');
        document.cookie = 'IncompletedQuoteBarClosed=; expires=-1; path=/';
    }


    /*****/

    /*****/
    //enquiry dropdowns inside a form
    function initEnquiryFormDropdowns() {
        var dropdowns = $(".js-enquiry-form-dropdown").not('.js-inited');
        if (!dropdowns.length)
            return;

        var genericdropdown = require('generic.dropdown');
        dropdowns.addClass('js-inited');

        dropdowns.each(function(i, element) {
            element.instance = new genericdropdown(dropdowns.eq(i), {
                time: 0.3,
                link: dropdowns.eq(i).find('.js-dropdown-link'),
                content: dropdowns.eq(i).find('.js-dropdown-content'),
                animationCallback: onAnimationComplete.bind(element)
            });
        });

        function onAnimationComplete() {
            var ddInstance = this.instance;
            focusFirstField(ddInstance);
            replaceButtonText(ddInstance)

        }

        function focusFirstField(ddInstance) {
            if (ddInstance.isOpened) {
                var firstField = ddInstance.dropdownContent.find('input').first();
                !firstField.val() && firstField.focus();
            }
        }

        function replaceButtonText(ddInstance) {
            var linkNode = ddInstance.dropdownLink;
            var closedText = linkNode.data('closedText');
            var openedText = linkNode.data('openedText');
            if (closedText === undefined || openedText === undefined) {
                return;
            }
            var textNode = linkNode.find('.js-dropdown-link-text');
            if (ddInstance.isOpened) {
                textNode.text(openedText);
            } else {
                textNode.text(closedText);
            }
        }
    }
    /*****/

    /*****/
    //lists of dropdown blocks looking like accordions that might need ajax loading for their content
    function initAccordions() {
        var accordions = $('.js-accordion-parent');
        if (!accordions.length)
            return;

        var genericdropdown = require('generic.dropdown');

        for (var i = 0, l = accordions.length; i < l; i++) {
            var accordion = accordions.eq(i),
                link = accordion.find('.js-accordion-opener'),
                body = accordion.find('.js-accordion-body');

            new genericdropdown(accordion, {
                link: link,
                content: body
            });

            link.on('click.toloadaccordion', accordionCallback.bind(accordion, link, body));
        }
    }

    function accordionCallback(link, body) {
        link.off('click.toloadaccordion');

        var url = link.attr('data-url');
        if (!url)
            return;

        link.addClass('loading');

        var dataAttributes = link.data(),
            settings = {},
            starting = 'param';

        for (var attr in dataAttributes) {
            if (attr.indexOf(starting) == 0)
                settings[attr.substr(starting.length).toLowerCase()] = dataAttributes[attr];
        }

        $.ajax({
            url: url,
            data:settings,
            success: loadSuccess.bind(this, link, body),
            error: loadError.bind(this, link, body)
        });
    }

    function loadSuccess(link, body, data) {
        var tabId = link.attr('data-id');
        if (tabId) {
            var content = $('<div></div').html(data).find('[data-tab="' + tabId + '"]'),
                div = $('<div class="accordion__content"></div>').html(content.length ? content.html() : '' );
            body.append(div);
            afterContentLoad();
            link.click();
        }
        link.removeClass('loading');
        this.addClass('loaded');
    }

    function loadError(link, body, data) {
        link.removeClass('loading');
        link.on('click.toloadaccordion', accordionCallback.bind(accordion, link, body));
    }

    function afterContentLoad() {
        $(window).trigger('tabs:init');
        $(window).trigger('video:init');
        $(window).trigger('gatracking:init');
        $(window).trigger('carousels:init');
        $(window).trigger('tabs:resize');
    }
    /*****/



    window.updateDropdowns = initTouchDropdowns;

    return {
        init: init
    };

}));



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.dropdowns.js
 ** module id = 37
 ** module chunks = 24
 **/